import { SupaUser } from "types";

import { supabase } from "../../services";

export const getUser = async () => {
  const { data, error } = await supabase.auth.getSession();

  if (error || !data.session) throw new Error(error?.message ?? "No user found");

  return data.session.user as SupaUser;
};
